<template>
  <div>

    <!--<CPortada :pseccion="pseccion"></CPortada>-->
    <Cbarra>
        <template slot="slotTitle">Gestión 2018-2022</template>
        <template slot="slotRoute">
            <router-link :to="{name:'index'}">Inicio</router-link> / <a href="#">Nosotros</a> / <router-link :to="{name:'gestion'}">Gestión 2018-2022</router-link>
        </template>
    </Cbarra>

    <div class="container">
        <div class="bg-principal-02">
            <div class="row" v-for="(item,index) in listGestion" :key="index">
                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                    <h3 class="color_Azul family-01" v-if="item.Titulo!=''">{{item.Titulo}}</h3>
                    <hr class="divider-02 hr-sm-left-0 bg-color"  v-if="item.Titulo!=''">
                    <p class="text-justify list-icon" v-html="item.Parrafo"></p>
                    <div class="row" v-for="(loop,key) in item.detalleMision" :key="key">
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" v-if="loop.TipoCont == 'PARRAFO'">
                            <h5 class="mb-3 color_Azul">{{loop.SubTitulo}}</h5>
                            <p class="text-justify list-icon">
                                <img :src="(loop.Imagen !='')?RutaFileC+loop.Imagen:''" class="parrafo-img" alt="ENES" v-show="loop.Imagen !=''">
                                <span v-html="loop.ParrafoCont"></span>
                            </p>
                        </div>
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 list-icon" v-else>
                            <h5 class="mt-3 mb-3 color_Azul">{{loop.SubTitulo}}</h5>
                            <ul>
                                <li v-for="(arc,key2) in loop.Archivos" :key="key2">
                                    <a :href="(arc.Archivo !='')?RutaFileA+arc.Archivo:''" target="blank_">{{arc.NombreArc}}</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" v-if="item.Tipo == 'SI'">
                    <hr class="divider-01">
                </div>
            </div>

        </div>
    </div>

    
  </div>
</template>

<script>

export default {
    name:'',
    components:{},
    data() {
        return {
            pseccion:'Gestion',
            listGestion: [],
            RutaFile:'',
            RutaFileC:'',
            RutaFileA:'',
        }
    },
    methods: {
        async GetDataGestion()
        {
            await this.$http.get(
                'inicio/mision/',
                {
                    params:{Seccion:'Gestion',TxtBusqueda:'',Entrada:'',pag:'', RegEstatus:'A',Orden:'SI'}
                }
            ).then( (res) => {
                this.listGestion = res.data.seccion;
                this.RutaFile = res.data.RutaFile;
                this.RutaFileC = res.data.RutaFileC;
                this.RutaFileA = res.data.RutaFileA;
            });
        },
    },
    mounted() {
        this.GetDataGestion();
    }
}
</script>